import { render, staticRenderFns } from "./SoldAssetTable.vue?vue&type=template&id=cb30554e&scoped=true&"
import script from "./SoldAssetTable.vue?vue&type=script&lang=js&"
export * from "./SoldAssetTable.vue?vue&type=script&lang=js&"
import style0 from "./SoldAssetTable.vue?vue&type=style&index=0&id=cb30554e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb30554e",
  null
  
)

export default component.exports